
export interface ApiErrorPayload {
    timeStamp?:string,
    status?:number,
    path?:string,
    type?:string,
    message:string,
    errorCode:string,
    params?:string[],
    keyValueParams?:{[key:string]:string}
}

export const isApiErrorPayload = (payload:any) => {
    return payload && payload.hasOwnProperty('errorCode');
}